import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { ChanelConfig } from '../../../configs/GlobalConfig';
import MessageHub from '../../../core/signalr/SignalrMessageHub';
import ConstCommon from '../../common/Const';
import Loading from '../../common/loading/Loading';
import ScrollComponent from '../../common/ScrollComponent';
import { withSyncDragCode } from '../../common/sync-drag-code';
import {
  getCodeFromQuery,
  getQueryParams,
  removeDragCode,
  syncComponentSelector,
} from '../../helpers/Common';
import ScoreBox from '../common/header/score-box';
import GroupButton from '../common/header/group-button';
import SearchBox from './common/SearchBox';
import ConsensusHistory from './consensus-history/ConsensusHistory';
import { Provider } from '../../common/ComponentIdContext';
import { ComponentNameProvider } from '../../common/ComponentNameContext';
import './consensus-analysis.scss';
import Recommendation from './recommendation/Recommendation';
import {
  fetchCompanyScore,
  fetchData,
  fetchLatestPrice,
  fetchLatestPriceSuccess,
  REDUCER_NAME,
  setCode,
} from './reducer';
import TargetPrice from './target-price/TargetPrice';
import PreRender from './../../common/PreRender';
import Notifications from '../common/header/notifications';

class ConsensusAnalysis extends PureComponent {
  constructor(props) {
    super(props);
    const { setCode, id } = this.props;
    const codeFromQuery = getCodeFromQuery(['stock']);
    if (codeFromQuery) {
      setCode(codeFromQuery, id);
      this.fetchData();
    }
  }

  componentDidMount() {
    const { glContainer } = this.props;
    if (!getQueryParams('code')) {
      this.fetchData();
    }
    removeDragCode(glContainer);
  }

  componentDidUpdate(prevProps) {
    const { organCode, locale } = this.props;
    if (locale !== prevProps.locale) {
      this.fetchData();
    }
    if (organCode !== prevProps.organCode && organCode) {
      this.fetchData();

      MessageHub.subscribe(ChanelConfig.TickChanel, this.onReceivePriceData);
    }
  }

  fetchData = () => {
    const {
      id,
      organCode,
      fetchData,
      fetchLatestPrice,
      fetchCompanyScore,
    } = this.props;
    fetchLatestPrice(
      {
        Code: organCode,
      },
      id,
    );
    fetchData(
      {
        OrganCode: organCode,
      },
      id,
    );

    fetchCompanyScore(
      {
        OrganCode: organCode,
      },
      id,
    );
  };

  onReceivePriceData = data => {
    const { code, fetchLatestPriceSuccess, id } = this.props;
    const price = data.find(item => item.ticker === code);
    if (price) {
      fetchLatestPriceSuccess(
        {
          priceInfo: price,
        },
        id,
      );
    }
  };

  render() {
    const { id, organCode, ticker, score, isLoading } = this.props;
    return (
      organCode && (
        <PreRender {...this.props}>
          <ComponentNameProvider
            value={ConstCommon.listComponent.ConsensusAnalysis}
          >
            <Provider value={id}>
              <ScrollComponent>
                <div className="pl-20 pr-20 pt-8 consensus-analysis-wrapper h-100 position-relative">
                  {isLoading && <Loading />}
                  <div
                    className={`top-nav d-flex flex-column h-100 ${
                      isLoading ? 'loading' : ''
                    }`}
                  >
                    <div className="d-flex mb-10 align-items-center flex-shrink-0">
                      <SearchBox componentId={id} />
                      <ScoreBox data={score} />
                      <GroupButton code={ticker} />
                      <Notifications data={score} />
                    </div>

                    <div className="tab-content flex-fill h-auto d-flex flex-row">
                      <div className="left-column d-flex flex-column">
                        <Recommendation />
                        <TargetPrice />
                      </div>
                      <div className="right-column d-flex align-self-baseline">
                        <ConsensusHistory />
                      </div>
                    </div>
                  </div>
                </div>
              </ScrollComponent>
            </Provider>
          </ComponentNameProvider>
        </PreRender>
      )
    );
  }
}

ConsensusAnalysis.propTypes = {
  id: PropTypes.number.isRequired,
  organCode: PropTypes.string.isRequired,
  ticker: PropTypes.string.isRequired,
  fetchData: PropTypes.func.isRequired,
  score: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  locale: PropTypes.string.isRequired,
};

const mapStateToProps = (state, { id, glContainer }) => ({
  organCode: state[REDUCER_NAME][id].currentSearch.code,
  ticker: state[REDUCER_NAME][id].currentSearch.displayCode,
  score: state[REDUCER_NAME][id].score,
  isLoading: state[REDUCER_NAME][id].isLoading,
  locale: state.i18n.locale,
  syncType: syncComponentSelector(
    state,
    ConstCommon.listComponent.ConsensusAnalysis,
    id,
  ),
});

const mapDispatchToProps = {
  fetchData,
  fetchLatestPrice,
  fetchCompanyScore,
  fetchLatestPriceSuccess,
  setCode,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withSyncDragCode,
)(ConsensusAnalysis);
